import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@leoclinic/hooks';
import { authService } from '@leoclinic/services';
import type { ReactNode } from 'react';

function LoadingScreen() {
  return (
    <div className="min-h-screen bg-[#F6F3EE] flex items-center justify-center">
      <p className="text-sm text-muted-foreground">A carregar...</p>
    </div>
  );
}

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) return <LoadingScreen />;

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!authService.hasRole(user, ['client'])) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
